const generateImages = (year, count, ext = 'jpg') =>
  Array.from({ length: count }, (_, i) => `/gallery/${year}/${i + 1}.${ext}`);

export const imagesByYear = {
  "2025": {
    title: "Highlights aus dem Jahr",
    subtitle: "2025",
    sections: [
      {
        subtitle: "Angeltreff",
        images: generateImages("2025/Angeltreff", 7, "jpeg"),
      },
            {
        subtitle: "Arbeitseinsatz",
        images: generateImages("2025/Arbeitseinsatz", 6, "jpeg"),
      }
    ]
  },
  "2024": {
    title: "Highlights aus dem Jahr",
    subtitle: "2024",
    sections: [
      {
        subtitle: "Arbeitseinsatz",
        images: generateImages("2024/Arbeitseinsatz", 6, "jpeg"),
      },
    ]
  },
    "2023": {
    title: "Highlights aus dem Jahr",
    subtitle: "2023",
    sections: [
      {
        subtitle: "Jahreshauptversammlung",
        images: generateImages("2023/Jahreshauptversammlung", 2, "jpg"),
      }
    ]
  },
  "2020": {
    title: "Highlights aus dem Jahr",
    subtitle: "2020",
    sections: [
      {
        subtitle: "Jahreshauptversammlung",
        images: generateImages("2020/Jahreshauptversammlung", 4, "jpg"),
      },
      {
        subtitle: "Angeltreff",
        images: generateImages("2020/Angeltreff", 1, "jpg"),
      },
      {
        subtitle: "Stralsund",
        images: generateImages("2020/Stralsund", 2, "jpg"),
      }
    ]
  },
      "2019": {
    title: "Highlights aus dem Jahr",
    subtitle: "2019",
    sections: [
      {
        subtitle: "Jahreshauptversammlung",
        images: generateImages("2019/Jahreshauptversammlung", 4, "jpg"),
      }
    ]
  },
  "2018": {
    title: "Highlights aus dem Jahr",
    subtitle: "2018",
    sections: [
      {
        subtitle: "Dessau",
        images: generateImages("2018/dessau", 6, "jpg"),
      }
    ]
  },
  "2017": {
    title: "Highlights aus dem Jahr",
    subtitle: "2017",
    sections: [
      {
        subtitle: "Dessau",
        images: generateImages("2017/dessau", 10, "jpg"),
      },
      {
        subtitle: "Jahreshauptversammlung",
        images: generateImages("2017/jahresversammlung", 7, "jpg"),
      },
    ],
  },
  // More years...
};
